import Button from 'ui/Button';
import Icon from 'ui/Icon';
import { Box } from 'ui/Layout';
import Menu from 'ui/Menu';

import { useSankeyFormContext } from '../../../../contexts/sankeyFormContext';
import { SankeyNode } from '../../../../diagram/types';
import { useTeamContext } from '../../../../utils/team';
import { addFlowToLeftOfNode, addFlowToRightOfNode } from './utils';

interface Props {
  node: SankeyNode;
}

const NodeAddFlowButton: React.FC<Props> = ({ node }) => {
  const { form } = useSankeyFormContext();
  const { teamSettings } = useTeamContext();

  const nodeName = form.watch(`nodes.${node.id}.name`);

  return (
    <Menu.Root>
      <Menu.Trigger>
        <Button variant="primary-solid" size="xs">
          <Icon icon="code-branch" /> Add flow
        </Button>
      </Menu.Trigger>
      {/* Don't use portal for this Menu since it's used in a Popover which is already portalled and the combination causes issues */}
      <Menu.Content portalled={false} minW="150px">
        <Menu.Item
          onClick={() => addFlowToLeftOfNode(form, nodeName, teamSettings)}
          value="add-to-left"
          fontSize="sm"
        >
          <Icon icon="arrow-left" />
          <Box flex={1}>Add to left</Box>
        </Menu.Item>
        <Menu.Item
          onClick={() => addFlowToRightOfNode(form, nodeName, teamSettings)}
          value="add-to-right"
          fontSize="sm"
        >
          <Icon icon="arrow-right" />
          <Box flex={1}>Add to right</Box>
        </Menu.Item>
      </Menu.Content>
    </Menu.Root>
  );
};

export default NodeAddFlowButton;
